/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_2_TitleInputs */

const en_mk_sec_2_title = /** @type {(inputs: Mk_Sec_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal tokens you can revoke`)
};

const id_mk_sec_2_title = /** @type {(inputs: Mk_Sec_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token pribadi yang bisa dicabut`)
};

/**
* | output |
* | --- |
* | "Personal tokens you can revoke" |
*
* @param {Mk_Sec_2_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_2_title = /** @type {((inputs?: Mk_Sec_2_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_2_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_2_title(inputs)
	return en_mk_sec_2_title(inputs)
});